<template>
  <header>
    <!-- IMAGE -->
    <div class="h-[40vh] w-full">
      <AppImage class="size-full object-cover" :src="data.image" />
    </div>

    <Container class="px-container-half pb-container pt-9 md:px-container-desktop md:py-18">
      <!-- TITLE -->
      <h1 v-if="data.heading" class="font-semibold typo-h1-sm" v-html="data.heading" />

      <!-- SUB TITLE -->
      <h2 v-if="data.sub_heading" class="typo-h1-sm" v-html="data.sub_heading" />

      <!-- LEAD TEXT -->
      <div v-if="data.text" class="wysiwyg-only-lists pt-7 typo-lead md:pt-9" v-html="data.text" />

      <!-- AUTHOR -->
      <div class="flex flex-col gap-4 pt-7 md:gap-8 md:pt-8 sm:flex-row sm:items-center">
        <!-- Image -->
        <div v-if="data.author" class="size-22 shrink-0">
          <AppImage class="size-full rounded-full object-cover" :src="data.author.image" />
        </div>
        <!-- Meta -->
        <div>
          <h3 v-if="data.author" class="mb-1 font-semibold typo-subtitle">
            {{ data.author.title }}
          </h3>
          <p class="flex flex-wrap typo-subtitle">
            <span>{{ $t('published') }} &nbsp;</span>
            <time :datetime="data.date">{{ dateFormatted }}</time>
            <template v-if="data.time_to_read">
              <span>&nbsp;|&nbsp;</span>
              <span>{{ $t('time_to_read') }} {{ data.time_to_read }}</span>
            </template>
          </p>
        </div>
      </div>
    </Container>
  </header>
</template>

<!-- eslint-disable-next-line vue/block-lang -->
<script setup>
const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
})

const dateFormatted = useDateFormatted(props.data)
</script>
